/* eslint-disable camelcase */
import { createReducer } from '@reduxjs/toolkit';
import { LoginActions } from './actions';
import Constants from './constants';

const initialState = {
  isSubmitting: false,
  error: null,
  requiresCaptcha: false,
  ssoProviders: null,
  fields: {},
};

const ACTION_HANDLER = {
  [LoginActions.submitLogin]: (state) => {
    state.isSubmitting = true;
    state.error = null;
  },
  [LoginActions.submitLoginSucceeded]: (state) => {
    state.isSubmitting = false;
  },
  [LoginActions.submitLoginFailed]: (state, action) => {
    state.isSubmitting = false;
    state.error = action.payload?.error || null;
    state.ssoProviders = action.payload?.sso_providers || null;
  },
  [LoginActions.setRequiresCaptcha]: (state, action) => {
    state.requiresCaptcha = action.payload;
  },
  [LoginActions.updateFields]: (state, action) => {
    state.fields = { ...state.fields, ...action.payload };
  },
};

export const loginReducer = createReducer(initialState, ACTION_HANDLER);

export default {
  name: Constants.MODULE_NAME,
  reducer: loginReducer,
};
